import '@vebox/etui-system';
import { Component, createElement } from 'react';
import { _ as _objectWithoutProperties, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Checkbox/CheckboxBase.js';
import '../Checkbox/CheckboxCircle.js';
import '../Checkbox/utils.js';
import Checkbox from '../Checkbox/Checkbox.js';

const _excluded = ["type", "rowIndex"];
function getCheckState(props) {
  const {
    store,
    defaultSelection,
    rowIndex
  } = props;
  let checked = false;
  if (store.getState().selectionDirty) {
    checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0;
  } else {
    checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0 || defaultSelection.indexOf(rowIndex) >= 0;
  }
  return checked;
}
class SelectionBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: getCheckState(props)
    };
  }
  componentDidMount() {
    this.subscribe();
  }
  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }
  subscribe() {
    const {
      store
    } = this.props;
    this.unsubscribe = store.subscribe(() => {
      const checked = getCheckState(this.props);
      this.setState({
        checked
      });
    });
  }
  render() {
    const _this$props = this.props,
      {
        type,
        rowIndex
      } = _this$props,
      rest = _objectWithoutProperties(_this$props, _excluded);
    const {
      checked
    } = this.state;
    return /*#__PURE__*/createElement(Checkbox, _extends({
      checked: checked,
      id: rowIndex,
      name: rowIndex
    }, rest));
  }
}

export default SelectionBox;
